// URL Indicator values for Tenant and Environment
const ENV = {
    ILLINOIS: {
        DEV: 'il-dev',
        QA: 'il-qa',
        UAT: 'il-uat',
        STG: 'il-stg',
        PROD: 'illinois'
    },
    OKLAHOMA: {
        DEV: 'ok-dev'
    },
    ARKANSAS: {
        STG: 'ar-stg',
        PROD: 'arkansas'
    },
    ARKANSAS_GOV: {
        DEV: 'ar-dev',
        QA: 'ar-qa',
        STG: 'ar-stg',
        PROD: 'arkansas',
    },
    MISSISSIPPI: {
        STG: 'ms-stg',
        PROD: 'mississippi'
    },
    SALES: {
        STG: 'sale-stg'
    }
};

// Tenant Name sent to ELP
const NAME = {
    [ENV.ILLINOIS.DEV]: 'Illinois',
    [ENV.ILLINOIS.QA]: 'Illinois',
    [ENV.ILLINOIS.UAT]: 'Illinois',
    [ENV.ILLINOIS.STG]: 'Illinois',
    [ENV.ILLINOIS.PROD]: 'Illinois',
    [ENV.OKLAHOMA.DEV]: 'Oklahoma',
    [ENV.ARKANSAS.STG]: 'Arkansas',
    [ENV.ARKANSAS.PROD]: 'Arkansas',
    [ENV.ARKANSAS_GOV.DEV]: 'Arkansas',
    [ENV.ARKANSAS_GOV.QA]: 'Arkansas',
    [ENV.ARKANSAS_GOV.STG]: 'Arkansas',
    [ENV.ARKANSAS_GOV.PROD]: 'Arkansas',
    [ENV.MISSISSIPPI.STG]: 'Mississippi',
    [ENV.MISSISSIPPI.PROD]: 'Mississippi',
    [ENV.SALES.STG]: 'Sales'
};

const DOMAIN = {
    LNP_WEB: 'lnpweb',
    ELP_GOV: 'elp.egov'
};

export const tenant = { 
    ENV,
    NAME,
    DOMAIN
};

export const tenantAgencyContacts = {
    'Illinois': [
        {name: 'Deaf and Hard of Hearing Commission (IDHHC)', email: 'ELP.IL.DHHC@onesupport.com'},
        {name: 'Illinois State Police (ISP)', email: 'ELP.IL.ISP@onesupport.com'},
        {name: 'Department of Human Rights', email: 'ELP.IL.DHR@onesupport.com'}],
    'Arkansas': [{name: 'Electrical Examiners', email: 'david.gray@arkansas.gov'},
        {name: 'Professional Geologists', email: 'kelli.black@arkansas.gov'},
        {name: 'Collection Agencies', email: ' rhonda.hetland@arkansas.gov' }]

};

export const tenantSupportEmail = {
    'Illinois': 'ELP.IL@onesupport.com',
};




// WEBPACK FOOTER //
// ./src/common/constants/tenant.js